<script>
    import f9button from "inputs/f9button.vue";

    export default {
        props: {
            hide: Function
        },
        components: {
            f9button
        }
    }
</script>

<template>
    <div class="password-requirements-container">
        <p>
            <strong>Password must be between 8 and 16 characters long and must include:</strong>
        </p>
        <ul>
            <li class="checkmark-gray"> One uppercase letter</li>
            <li class="checkmark-gray"> One lowercase letter</li>
            <li class="checkmark-gray"> One number</li>
            <li class="checkmark-gray"> One special character</li>
            <li class="xmark-gray"> Cannot contain period (.) comma (,) tilde (~) or underscore (_)</li>
        </ul>
        <f9button v-if="hide" @click="hide">RETURN TO SIGN UP</f9button>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    .password-requirements-container {
        font-size: 16px;

        p {
            color: @frontier-gray-dark;
            line-height: 150%;
        }

        .checkmark-gray, .xmark-gray {
            list-style: none;
            padding: .2em 0 .2em 0;
        }

        .checkmark-gray::before{
            content: '\2713';
            color: @frontier-gray-dark;
        }

        .xmark-gray::before{
            content: '\2717';
            color: @frontier-gray-dark;
        }

        ul {
            padding-left: 0px;

            li {
                color: @frontier-gray-dark;
            }
        }
    }
</style>